import { PhoneIcon, EnvelopeIcon } from "@heroicons/react/24/solid";
// import PrimaryLogo from "../../assets/images/primarylogo.png";
import NewLogo from "../../assets/images/newlogohorizontal.png";
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from "react-icons/fa";

import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="w-full flex justify-center items-center my-4">
      <div className="w-full flex flex-col gap-4 lg:flex-row lg:justify-between lg:items-start p-4">
        {/* Logo Section */}
        <div className="w-full lg:w-1/4 flex flex-col items-center lg:items-start mb-4 lg:mb-0">
          <img
            src={NewLogo}
            alt="Primary Logo"
            className="h-12"
            style={{
              height: "55px",
              width: "auto",
            }}
          />
          <div className="mt-4 flex flex-col gap-1 text-sm text-gray-500 text-center lg:text-left">
            <p>DUNS Number: 931839180</p>
            <p>CIN Number: U63030TS2022PTC222199</p>
          </div>
        </div>

        {/* Links Section */}
        <div className="gap-3 sm:gap-12 text-center lg:text-left w-full lg:w-3/4 flex justify-between flex-col sm:flex-row  sm:justify-center">
          <div className="w-full sm:w-1/3  lg:mb-0">
            <div className="font-mazzardbold text-xl mb-2">Company</div>
            <ul>
              <li className="text-md mb-1">
                <Link
                  to="/about"
                  className="hover:text-blue-600 transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li className="text-md mb-1">
                <Link
                  to="/services"
                  className="hover:text-blue-600 transition-colors"
                >
                  Services
                </Link>
              </li>
              <li className="text-md mb-1">
                <Link
                  to="/contact"
                  className="hover:text-blue-600 transition-colors"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="w-full sm:w-1/3   lg:mb-0">
            <div className="font-mazzardbold text-xl mb-2">Legal</div>
            <ul>
              <li className="text-md mb-1">
                <Link
                  to="/privacy"
                  className="hover:text-blue-600 transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li className="text-md mb-1">
                <Link
                  to="/terms"
                  className="hover:text-blue-600 transition-colors"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
          <div className=" w-full sm:w-1/3  lg:mb-0 ">
            <div className="font-mazzardbold text-xl mb-2">Platforms</div>
            <ul className="">
              <li className="text-md mb-1">Admin</li>
              <li className="text-md mb-1">Vendor</li>
              <li className="text-md mb-1">Driver</li>
            </ul>
          </div>
        </div>

        {/* Contact Section */}
        <div className="w-full lg:w-1/4 flex flex-col items-center lg:items-start">
          <h2 className="text-lg font-bold mb-2">Contact Us</h2>
          <div className="mb-4">
            <h3 className="font-mazzardbold text-lg mb-2">
              SNR Fleet Services Private Limited
            </h3>
          </div>
          <p className="flex items-center mb-2">
            <PhoneIcon className="h-5 w-5 mr-2" />
            <a
              href="tel:+918309412828"
              className="text-blue-600 hover:text-blue-800 transition-colors"
            >
              +91 8309412828
            </a>
          </p>
          <p className="flex items-center mb-4">
            <EnvelopeIcon className="h-5 w-5 mr-2" />
            <a
              href="mailto:ride@fusioncab.com"
              className="text-blue-600 hover:text-blue-800 transition-colors"
            >
              ride@fusioncab.com
            </a>
          </p>
          <div className="w-full lg:w-1/4 flex flex-col items-center lg:items-start">
            <h3 className="font-mazzardbold text-lg mb-3">Follow Us</h3>
            <div className="icons flex gap-4">
              <a
                href="https://x.com/FusionCab"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-blue-400 transition-colors duration-300 transform hover:scale-110"
              >
                <FaTwitter className="h-6 w-6" />
              </a>
              <a
                href="https://www.instagram.com/fusioncab"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-pink-500 transition-colors duration-300 transform hover:scale-110"
              >
                <FaInstagram className="h-6 w-6" />
              </a>
              <a
                href="https://www.facebook.com/info.fusioncab"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-blue-600 transition-colors duration-300 transform hover:scale-110"
              >
                <FaFacebook className="h-6 w-6" />
              </a>
              <a
                href="https://www.linkedin.com/company/fusion-cab/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-blue-700 transition-colors duration-300 transform hover:scale-110"
              >
                <FaLinkedin className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
